// navigation.js
import { createContext, useContext, useMemo, useReducer } from 'react';

function navigationReducer(state, action) {
  switch (action.type) {
    // projectManager | pdcPage | machine | product
    case 'mainPage':
      return { ...state, mainPage: action.payload };

    case 'currentPage':
      return { ...state, currentPage: action.payload };

    case 'productCurrentPage': // menu: | tab:
      return {
        ...state,
        productCurrentPage: {
          ...state.productCurrentPage,
          ...action.payload,
        },
      };

    case 'expandedMenu':
      return { ...state, expandedMenu: action.payload };

    case 'expandedMenuItem':
      return { ...state, expandedMenu: action.payload };

    case 'showOptions':
      return { ...state, showOptions: action.payload };

    case 'focusedInput':
      return { ...state, focusedInput: action.payload };

    case 'addWindingsSelected':
      if (state.addWindingsSelected === action.payload) return state;
      return { ...state, addWindingsSelected: action.payload };

    case 'spiralView':
      if (state.spiralView === action.payload) return state;
      return { ...state, spiralView: action.payload };

    case 'phoneMenu':
      return { ...state, phoneMenu: action.payload };

    case 'focusedProduct':
      return { ...state, focusedProduct: action.payload };

    case 'productSizeView':
      return { ...state, productSizeView: action.payload };

    case 'feedbackPanelOpen':
      return { ...state, feedbackPanelOpen: Boolean(action.payload) };

    default:
      return state;
  }
}

const NavigationContext = createContext(null);

export function useNavigation() {
  const ctx = useContext(NavigationContext);
  if (!ctx) {
    throw new Error('useNavigation must be used within <NavigationProvider>');
  }
  return ctx;
}

export function NavigationProvider({ children, initial }) {
  const [nav, dispatch] = useReducer(navigationReducer, initial);
  const value = useMemo(() => ({ nav, dispatch }), [nav]);

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
}
